import React from "react"

import "./Tabs.css"

import TabButton from "./VerticalTabButton"

import "../Navbar/react-dd-menu.css"

// for use in CollegeCalendar - WIP
function VerticalTabs(props) {
  const clickTab = (key, index) => {
    props.onClickFun(key, index)
  }

  let tabs = props.tabs

  return (
    <div className={"buttonTabGroupVertical"}>
      {tabs.map((tab, index) => {
        tab.onClick = () => {
          clickTab(tab.key, index)
        }
        return (
          <TabButton
            active={tab.active}
            text={tab.text}
            disabled={tab.disabled}
            onClick={tab.onClick}
            addNew={tab.addNew}
            key={index}
            expired={tab.expired_time ? new Date(tab.expired_time) < new Date() : false}
          />
        )
      })}
    </div>
  )
}

export default VerticalTabs
